import React from "react";
import { Route, Routes } from "react-router";
import TicketPortal from "./TicketPortal";
import "../../../stylesheets/components/features/TicketPortal/TicketPortal.scss";
import NewTicket from "./NewTicket";
import DeviceContext from "@frameworks/web/components/generic/customHooks/indentifyDevice";
const TicketPortalRouting = () => {
    const device = DeviceContext();
    return (React.createElement(React.Fragment, null,
        React.createElement(Routes, null,
            React.createElement(Route, { path: "/ticket-portal", element: React.createElement(TicketPortal, null) }),
            React.createElement(Route, { path: "/new-ticket", element: device && device.isDesktop ? (React.createElement(React.Fragment, null)) : (React.createElement(React.Fragment, null,
                    React.createElement(NewTicket, null))) }))));
};
export default TicketPortalRouting;
